import * as tslib_1 from "tslib";
import { OnInit, } from '@angular/core';
import { AppStateFacade } from '@app-state';
import { UiModalComponent } from '@components/ui-modal/ui-modal.component';
import { MLSkillStatus, } from '@models';
import { MLSkillsIOParametersComponent } from '@pages/ml/mlskills/subviews/mlskills-io-parameters';
import { BehaviorSubject, } from 'rxjs';
var MLSkillVersionsModalComponent = /** @class */ (function (_super) {
    tslib_1.__extends(MLSkillVersionsModalComponent, _super);
    function MLSkillVersionsModalComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading$ = new BehaviorSubject(false);
        return _this;
    }
    MLSkillVersionsModalComponent.prototype.ngOnInit = function () {
        var appState = this._injector.get(AppStateFacade);
        this.isMLSkillEditAllowed = appState.user.permissions.isGranted('MLSkills.Edit');
    };
    MLSkillVersionsModalComponent.prototype.onClose = function () {
        var closeResult = this.context.data.status === MLSkillStatus.Updating ?
            {
                type: 2 /* Update */,
                data: this.context.data,
            } :
            undefined;
        this._dialogRef.close(closeResult);
    };
    MLSkillVersionsModalComponent.prototype.onUpdate = function (skillList) {
        this.context.data = skillList[0];
    };
    return MLSkillVersionsModalComponent;
}(UiModalComponent));
export { MLSkillVersionsModalComponent };
